import { PopupOpenEventArgs } from '@syncfusion/ej2-react-schedule';
import { DUMMY_PROJECT_ID } from 'state/Schedule/ScheduleSlice';

export const generateExistingEventData = (
  args: PopupOpenEventArgs,
  eventTypeId: string,
  startTime: string,
  endTime: string,
  isOldEvent: boolean
) => {
  const eventOriginalProjectIds =
    args.data?.projects?.map((project: { id: string }) => project.id) || [];
  const dummyProjectExists = eventOriginalProjectIds.includes(DUMMY_PROJECT_ID);
  const projectIds = dummyProjectExists ? [] : args.data?.ProjectId || [];
  const projects = dummyProjectExists ? [] : args.data?.projects || [];
  return {
    id: args.data?.Id,
    subject: args.data?.Subject || '',
    description: args.data?.description ?? args.data?.Description ?? null,
    startTime: startTime,
    endTime: endTime,
    projectIds: projectIds,
    createdBy: args.data?.CreatedBy,
    learningEventType: eventTypeId,
    isAllDay: args.data?.IsAllDay,
    recurrenceRule: args.data?.RecurrenceRule,
    recurrenceException: args.data?.RecurrenceException,
    projects: projects,
    isOldEvent: isOldEvent,
    facilitators: args.data?.facilitators || [],
    facilitatorIds: (args.data?.facilitators ?? [])
      .map((facilitator: { id: string; name: string }) => facilitator.id)
      .sort(),
  };
};
